import {
    Collapse,
    IconButton,
    iconButtonClasses,
    List,
    listItemButtonClasses,
    Stack,
    useMediaQuery,
    useTheme,
} from '@mui/material'
import * as React from 'react'
import { FC, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useThreadListApiV1CollaborationAppThreadGet } from '../../../../api/gen/base'
import ArrowIcon from '../../../../assets/icons/ChevronDown.svg?react'
import FolderIcon from '../../../../assets/icons/Folder.svg?react'
import { PROJECT_ROUTE } from '../../../../constants/routing.constants'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { theme } from '../../../../theme'
import ShieldCheck from './../../../../assets/icons/ShieldCheck.svg?react'
import { NavigationButton } from './NavigationButton'
import { OnboardingTooltip } from './OnboardingTooltip'
import { RequestNavigationButton } from './RequestNavigationButton'

type Props = {
    title: string
    projectId: string
    onOpenProject: (id: string) => void
}

const NUMBER_REQUESTS_TO_SHOW = 3

export const ProjectsAccordion: FC<Props> = ({
    index,
    title,
    projectId,
    onOpenProject,
    is_protected,
}) => {
    const { breakpoints } = useTheme()
    const { pathname, search } = useLocation()
    const { setOpenSidebar, stepOnboarding } = useWrapperStore((state) => state)

    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const [expanded, setExpanded] = useState(false)

    const { data, isLoading } = useThreadListApiV1CollaborationAppThreadGet({
        limit: NUMBER_REQUESTS_TO_SHOW,
        workplace_id: projectId,
        is_archived: false,
    })

    const handleOpenProject = () => onOpenProject(projectId)

    const handleToggleExpanded = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()

        setExpanded((prev) => !prev)
    }

    const requests = data?.objects ?? []

    const Wrapper = ({ children }) => (
        <OnboardingTooltip
            placement="right-start"
            open={!isMobile && index === 0 && stepOnboarding === 4}
            title="Проекты"
            decription="Объединяют запросы, файлы и инструкции в одном месте. Контекст сохраняется и учитывается в работе">
            {' '}
            {children}
        </OnboardingTooltip>
    )

    return (
        <Wrapper>
            <Stack>
                <NavigationButton
                    isProjectStepOnboarding={index === 0 && stepOnboarding === 4}
                    onClick={handleOpenProject}
                    disabled={isLoading && stepOnboarding === 4}
                    startIcon={<FolderIcon color="#5A5F72" />}
                    isActive={
                        pathname === `${PROJECT_ROUTE}/` &&
                        search.includes(`workplaceId=${projectId}`)
                    }
                    endIcon={
                        <IconButton
                            disabled={stepOnboarding !== 100}
                            onClick={handleToggleExpanded}
                            sx={{
                                svg: {
                                    rotate: expanded ? '180deg' : 0,
                                },
                            }}>
                            <ArrowIcon />
                        </IconButton>
                    }
                    sx={{
                        // pointerEvents: stepOnboarding === 100 ? 'auto':  'none' ,
                        backgroundColor:
                            stepOnboarding === 4 && index === 0
                                ? '#EBF5FD !important'
                                : stepOnboarding === 4 || stepOnboarding === 2
                                  ? '#7f7f7f'
                                  : '#fff',
                        [`.${iconButtonClasses.root}`]: {
                            visibility: expanded || isMobile ? 'visible' : 'hidden',
                        },
                        ':hover': {
                            [`.${iconButtonClasses.root}`]: {
                                visibility: 'visible',
                            },
                        },
                    }}>
                    <Stack direction="row" sx={{ alignItems: 'center' }}>
                        {title}
                        {is_protected && (
                            <IconButton
                                sx={{
                                    p: 0,
                                    width: '16px',
                                    height: '16px',
                                    ml: '6px',
                                    visibility: 'visible !important',
                                }}>
                                <ShieldCheck
                                    style={{
                                        color: '#5A5C5E',
                                        height: '12px',
                                        width: '12px',
                                    }}
                                />
                            </IconButton>
                        )}
                    </Stack>
                </NavigationButton>
                <Collapse in={expanded}>
                    <List
                        sx={{
                            p: 0,
                            [`.${listItemButtonClasses.root}`]: {
                                pl: 3.5,
                            },
                        }}>
                        {requests.map((request) => (
                            <RequestNavigationButton key={request.id} request={request} />
                        ))}
                        <NavigationButton onClick={handleOpenProject} textColor="#5A5F72">
                            Все запросы в проекте
                        </NavigationButton>
                    </List>
                </Collapse>
            </Stack>
        </Wrapper>
    )
}
